import React from 'react';
import { AppBar, Toolbar, IconButton, Box } from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';
import AddIcon from '@mui/icons-material/Add';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  toggleDrawer: () => void;
}

export const Header: React.FC<HeaderProps> = ({ toggleDrawer }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handlePlusClick = () => {
    navigate('/orders');
  };

  return (
    <AppBar position="fixed" sx={{ backgroundColor: theme.palette.primary.main }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {/* Left section with drawer icon and logo */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton edge="start" color="inherit" onClick={toggleDrawer}>
            <AppsIcon />
          </IconButton>
          <Box
            component="img"
            src="/images/logo-line.png"
            alt="TayHub"
            sx={{
              height: 35,
              ml: 1,
              objectFit: 'contain',
            }}
          />
        </Box>

        {/* Right section with plus icon */}
        <IconButton color="inherit" onClick={handlePlusClick}>
          <AddIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};
